import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
const EventsSection = () => {
  const sectionRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["0 1", "1.5 1"],
  });

  const middleBoxX = useTransform(scrollYProgress, [0, 1], [0, -200]);
  const sideBoxY = useTransform(scrollYProgress, [0, 1], [0, -150]);
  const navigate = useNavigate();

  return (
    <section
      ref={sectionRef}
      className="relative max-w-full px-14  flex flex-col md:flex-row items-center justify-between bg-[#1a180e] text-white overflow-hidden py-24    md:gap-10 "
    >
      <motion.div
        style={{ y: sideBoxY }}
        className="absolute top-0 left-0 w-64 h-64 flex items-center justify-center"
      >
        <div className="w-full h-full border-2 border-primaryColor rotate-45 opacity-70"></div>
      </motion.div>

      <motion.div
        style={{ x: middleBoxX }}
        className="absolute right-[35%] bottom-20 w-96 h-96 flex items-center justify-center"
      >
        <div className="w-full h-full border-2 border-primaryColor rotate-45 opacity-70"></div>
      </motion.div>

      <motion.div
        style={{ y: sideBoxY }}
        className="absolute bottom-0 right-0 w-64 h-64 flex items-center justify-center"
      >
        <div className="w-full h-full border-2 border-primaryColor rotate-45 opacity-70"></div>
      </motion.div>

      <div className="relative z-10 md:w-1/2 space-y-6 xl:ml-32  ">
        <h1 className="text-4xl md:text-5xl font-bold leading-tight heading">
          Online Events are Amazing Opportunities to Have Fun and Learn
        </h1>
        <p className="text-gray-300 leading-relaxed sub-heading tracking-wide">
          Online events provide exciting opportunities to learn, connect, and
          grow from anywhere. These include live webinars, workshops, and
          interactive sessions led by industry experts. Participants can engage
          in discussions, ask questions in real time, and gain valuable insights
          into trending topics. Online events make learning more accessible,
          flexible, and engaging for everyone. .
        </p>
        <button
          onClick={() => {
            navigate("/events");
          }}
          className="relative w-1/2 xl:w-1/4 bg-gradient-to-r from-primaryColor to-secondaryColor text-white  font-bold rounded-xl py-4 overflow-hidden group transition-all duration-300 hover:scale-105 shadow-primaryColor"
        >
          <span className="absolute inset-0 bg-gradient-to-r from-primaryColor to-secondaryColor text-white  opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-in-out"></span>

          <span className="relative block transition-transform duration-500 ease-in-out group-hover:-translate-y-10 sub-heading">
            All Events
          </span>
          <span className="absolute inset-0 flex items-center justify-center translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-in-out font-bold text-white sub-heading">
            All Events
          </span>
        </button>
      </div>

      <div className="relative z-10 md:w-1/2 translate-y-20 flex justify-center mt-10 md:mt-0 px-20 ">
        <div className="bg-primaryColor rounded-xl p-1  ">
          <div className="bg-white text-black rounded-2xl shadow-xl border-4 p-6 xl:w-[450px] -translate-y-2 -translate-x-2 ">
            <h2 className="text-xl font-bold mb-4 heading">
              Most Popular Events
            </h2>

            {[1, 2, 3, 4].map((i) => (
              <div
                key={i}
                className="border-t border-gray-200 py-4 flex gap-1 sub-heading"
              >
                <div className="flex flex-col items-center gap-3">
                  <div className="text-3xl font-bold text-black leading-none font-nunitosans">
                    12
                  </div>
                  <div>
                    <div className="text-xs uppercase text-gray-600">
                      February
                    </div>
                    <div className="text-sm font-semibold text-black">
                      03:50 PM
                    </div>
                  </div>
                </div>
                <div className="-translate-y-2 translate-x-2">
                  <h3 className="font-bold font-barlow text-black text-2xl mt-1 heading">
                    Digital Transformation Conference
                  </h3>
                  <p className="text-sm text-gray-600">
                    Prepare for: Lora Hill
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
export default EventsSection;
